define( [
	"../data/var/dataPriv"
], function( dataPriv ) {

// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}

return setGlobalEval;
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/manipulation/setGlobalEval.js
 ** module id = 451
 ** module chunks = 2
 **/